
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/home-modifications-visually-impaired-and-blind",
      function () {
        return require("private-next-pages/articles/home-modifications-visually-impaired-and-blind.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/home-modifications-visually-impaired-and-blind"])
      });
    }
  